<template>
    <div class="all">
      <v-header title="产品"></v-header>
        <div class="content">
          <el-row type="flex"  justify="center">
            <el-col span="18">
              <el-input placeholder="请输入内容" v-model="searchText" class="input-with-select">
                <el-button slot="append" size="medium" icon="el-icon-search" @click="search()" class="topbutton"></el-button>
              </el-input>
            </el-col>
          </el-row>
          
          <div class="chanpin">
            <el-row :gutter="20"  class="row-box" >
              <el-col :span="6" class="col-box"  v-for="(item) in products" :key="item.key" >
                  <div  class="prolist-one" @click="toURLParameter(item.pageUrl)">
                    <div class="imgbox"><img :src=item.picUrl></div>
                    <div class="protxt">
                      <div class="subject">{{item.title}}
                        <!-- <span>分红型</span> -->
                        </div>
                      <div class="info">{{item.prodIntroducton}}</div>
                      <div class="tag"><span v-for="(subitem,subindex) in item.keywords" :key="subitem.key" v-if="subindex<1">{{subitem}}</span></div>
                    </div>                    
                  </div>           
              </el-col>
              
            </el-row>
            <div  v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="12">
                <div v-show="loadingShow" class="loading">
                  <div class="demo0">加载中</div>
                  <div  id="loading1">
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                      <div class="demo1"></div>
                  </div>
                </div>
                <el-row>
                  <el-col :span="24" class="nodata" v-show="nodata">暂无数据</el-col>
                </el-row>
                <div v-show="line" class="line">
                <span>我是有底线的</span>
                </div>
            </div>
          </div>

           




        </div>
        <!-- 置顶 -->
        <transition name="fade">
          <div class="return-top" id="return-top" v-show="returntop"  @click="gotop"><img src="../../static/image/returntop.png"></div>
        </transition>

    </div>

</template>
<script>
import api from '@/modules/api.js'
import url from '@/modules/url.js'
import vHeader from '@/layout/Header1.vue'
let timer = null // 定义初始值
export default {
  // name: '首页',
  components:{vHeader},
  data () {
    return {
      result: '',
      password: '',
      username: '',
      items: [],
      imglist: [],
      day: '',
      date: '',
      conbox: true,
      returntop: false,
      products:[],
      searchText:'',
      pageSize: 12,
      currentPage: 1,
      busy: true, //是否正在加载过程中,true为繁忙的时候不执行loadMore,false则执行
      loadingShow:false,//是否显示加载中提示文字
      line:false,
      nodata:false
    }
  },
  computed: {},
  methods: {
    // 鼠标滚动
    changetime (data) {
      let getDate = new Date(data)
      let y = getDate.getFullYear()
      let M = getDate.getMonth() + 1
      let d = getDate.getDate()
      let format = y + '-' + M + '-' + d
      return format
    },
    search(){
      // alert(this.searchText)
      let that = this
      that.busy = true
      that.currentPage = 1
      that.getProducts(false)
    },
    getProducts (flag) {
      let that = this
      let msg = {
        pageSize: that.pageSize,
        currentPage: that.currentPage,
        searchText:that.searchText
      }
      api.post(that.$url.getProducts,msg, res => {
        console.log(res,"所有产品数据")
        if (res.result.isSuccess === true) {
          // let data = res.data.products
          // data.forEach(response => {
          //     // console.log(response.title,'------------')
          //     response.keywords = response.keywords.split(',')
          //     that.products.push(response)
          //   })

          // alert(flag)
          if(flag){            
            // 多次加载数据
              that.products = that.products.concat(res.data.products)
              if(res.data.products.length == 0){
                  that.busy = true;
                  that.loadingShow = false
                  that.line = true
              }else{
                  that.busy = false;
                  that.loadingShow = true
                  that.line = false
              }
          }else{
              // 第一次加载数据
              // alert(that.products.length)
              that.products = res.data.products
              if(res.data.products.length<that.pageSize){
                //小于10条数据不滚动加载busy设为true
                // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
                // alert(res.data.products.length+":<10")
                that.busy = true
                that.line = true
                that.loadingShow = false
              }else{
                that.line = false
                that.loadingShow = true
                // 当第一次加载数据完之后，把这个滚动到底部的函数触发打开
                that.busy = false
              }            
             
          }
          if(res.data.total == 0){
                that.nodata = true
                that.line= false
                // this.$toast.message("没有查到数据")
          }
        }
      })
    },
    loadMore () {
      this.currentPage++
      this.getProducts(true);
      // this.busy = true;
      // alert(0)
      // 多次加载数据
      // setTimeout(() => {
      //     this.currentPage ++;
      //     this.getProducts(true);
      // }, 1000);
    },
    handleScroll () {
      // var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var scrollTop = document.querySelector('.chanpin').scrollTop
      if (scrollTop > 200) {
        this.returntop = true
      } else {
        this.returntop = false
      }
    },
    gotop () {
      // document.querySelector('#main_div').animate({
      //     'scrollTop': 0
      // }, 'fast');
      // document.querySelector('#main_div').scrollTop=0
      var box = document.querySelector('.chanpin')
      timer = setInterval(function () {
        let osTop = box.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        box.scrollTop = osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 30)
    },
    toURLParameter(url){
      let that = this
      // alert(url)
      if (url === '') {
          that.$message('敬请期待')
      } else {
          if (url.slice(0, 4) === 'http') {
            // tempurl = url
            // window.location.href = tempurl
            window.open(url)
          }  else {
            if(url.slice(0, 1) === '/')
            {
              that.$router.push({path: url})
            }else{
              that.$router.push({path:'/' + url})
            }           
          }
      }
    }
  },
  mounted () {
    this.getProducts(false)
    var mainDiv = document.querySelector('.chanpin')
    mainDiv.addEventListener('scroll', this.handleScroll)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // 参数vm就是当前组件的实例。
      vm.check()
    })
  }

}
</script>
<style scoped>
.all {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  /* min-height: 100%; */
  /* background: #fff; */
}
/* ul,
li {
  list-style: none;
  padding-inline-start: 0px;
} */
.content {
  width: 96%;
  height: calc(100% - 100px);
  margin: 0 auto;
  padding:20px 0;
  margin-top: 20px;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
  /* margin-top:2%;
  margin-bottom: 2%; */
}
/* .content::-webkit-scrollbar{width:2px;}
.content::-webkit-scrollbar-thumb{background:rgba(193,193,193, .4);} */
.topbutton{
  color: #FFFFFF !important;
  background-color: #194793 !important;
  height: 40px;
  border-radius: 0 4px 4px 0;
  border: 0;
  width: 70px;
}
/* 产品 */
.chanpin {
  width: 100%;
  margin: 0 auto;
  padding:0 20px;
  margin-top: 20px;
  box-sizing: border-box;
  overflow: auto;
  height: calc(100% - 60px);
  /* margin-top: 3%; */
  /* padding-bottom: 30px; */
  /* height: calc(100% - 39px); */
}
.chanpin::-webkit-scrollbar{width:2px;}
.chanpin::-webkit-scrollbar-thumb{background:rgba(193,193,193, .4);}
/* .chanpin img {
  width: 100%;
  height: 100%;
} */
.chanpin img {
  width: 100%;
  /* height: 100%; */
}
/* .row-box{
   height:100%;
} */
.col-box{
  height:100%;
  margin-bottom: 20px;
}
.prolist-one{
  cursor:pointer;
  /* height: 100%; */
  height:220px;
  padding:10px 8px;
  box-sizing: border-box;
  /* border:1px solid #fff; */
}
.prolist-one:hover{
  border:1px solid rgba(233,233,233,1);
  box-shadow:0px 5px 15px 0px rgba(188, 238, 213, 0.35);
}
.imgbox{
  /* max-height: 102px; */
  /* max-height: 90px; */
  height: 60%;
  overflow: hidden;
}
.protxt{
  height: 40%;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  /* align-items:stretch; */
  align-content:flex-end;
}
.chanpin .subject{ 
  color:#002C76; 
  font-size: 12px;
  font-weight: bold;
  line-height: 24px;
  
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chanpin .subject span{
  background:#FF6969;
  padding: 1px 4px;
  margin-left: 3px;
  border-radius: 3px;
  color: #fff;
  font-size: 10px;
}
.chanpin .info{
  font-size: 12px;
  line-height: 24px;
  color: #9E9FA0;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}
.chanpin .tag{
  margin-top: 1%;
  /* margin-bottom: 10px; */
}
.chanpin .tag span{
  border: 1px solid #18C29C;
  border-radius: 3px;
  padding: 1px 4px;
  color: #18C29C;
  margin-right: 5px;
  font-size: 10px;
  max-width: 73%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 返回顶部 */
.return-top{ width:70px; position: fixed; right:30px; bottom: 20px;}
.return-top img{ width:100%;}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.line{
  width: 100%;
  margin: auto;
  margin-top: 20px;
  border-top:1px solid #E5E5E5;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.line span{
  color: #E5E5E5;
  font-size: 12px;
  background:#fff;
  padding:0 2px;
  position: absolute;
  top:-8px;
}
.nodata{
  color: #666;margin-top: 20px; text-align: center;
}
.load-more-normal {
    text-align: center;
    height: 60px;
    line-height: 60px;
  }

  .load-more-hide {
    height: 0;
  }

  .loading{
    height: 30px;
    line-height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
.demo0{color:#ccc;font-size: 14px; float: left; margin-right: 6px;}
  .demo1 {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    background: #ccc;
    float: left;
    margin: 0 3px;
    animation: demo1 linear 1s infinite;
    -webkit-animation: demo1 linear 1s infinite;
}
.demo1:nth-child(1){
    animation-delay:0s;
}
.demo1:nth-child(2){
    animation-delay:0.15s;
}
.demo1:nth-child(3){
    animation-delay:0.3s;
}
.demo1:nth-child(4){
    animation-delay:0.45s;
}
.demo1:nth-child(5){
    animation-delay:0.6s;
}
@keyframes demo1 
{
    0%,60%,100% {transform: scale(1);}
    30% {transform: scale(2.5);}
}
@-webkit-keyframes demo1 
{
    0%,60%,100% {transform: scale(1);}
    30% {transform: scale(2.5);}
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {

}
</style>



// WEBPACK FOOTER //
// src/pages/proList.vue